/**
 * Get error classes based on error state
 */
export const getErrorInputClasses = (error?: string) => {
  return error ? 'error' : ''
}

/**
 * Label classes for form inputs
 */
export const labelClasses = 'size-body-sm font-medium text-white-950 mb-xs'

/**
 * Error message classes
 */
export const errorClasses = 'size-body-xs font-normal text-semantic-error mt-xs'

/**
 * Helper text classes
 */
export const helperClasses = 'size-body-sm font-normal text-white-700 mt-xs'
